<template>
  <div class="parenthesis-node">
    <button
      class="parenthesis-node__remove-btn"
      @click.stop="$emit('on-close')"
    />
    <div>
      {{ modelValue }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['on-close']
}
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "#src/assets/scss/variables" as *;

.parenthesis-node {
  user-select: none;
  width: fit-content;
  position: relative;
  background: white;
  box-shadow: 0 2px 4px 0 color.change(black, $alpha: 0.1);
  border-radius: 2px;
  padding: 0.5rem 1rem;

  &:hover {
    .parenthesis-node__remove-btn {
      visibility: visible;
    }
  }
}

.parenthesis-node__remove-btn {
  position: absolute;
  top: -0.4rem;
  right: -0.4rem;
  width: 1.25rem;
  height: 1.25rem;
  overflow: hidden;
  background-color: white;
  border-radius: 100%;
  text-indent: 100%;
  border: 1px solid $light-blue;
  visibility: hidden;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='7' height='7' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.7071.2929L3.121 1.706 4.53553.2929c.39053-.39053 1.0237-.39053 1.41422 0 .39052.39052.39052 1.02368 0 1.4142L4.535 3.121l1.41475 1.41453c.39052.39053.39052 1.0237 0 1.41422-.39053.39052-1.0237.39052-1.41422 0L3.121 4.535 1.7071 5.94975c-.39052.39052-1.02368.39052-1.4142 0-.39053-.39053-.39053-1.0237 0-1.41422L1.706 3.121.2929 1.7071c-.39053-.39052-.39053-1.02368 0-1.4142.39052-.39053 1.02368-.39053 1.4142 0z' fill='%238F95A1' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-size: 0.5rem 0.5rem;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-color: white;
  }
}
</style>
